import type React from "react";
import { memo } from "react";
import type { CommenterDefinition } from "../../types/core";
import {
	TranscriptionDisplay,
	type TranscriptSegment,
} from "./TranscriptionDisplay";

interface TranscriptPanelProps {
	segments: TranscriptSegment[];
	commenterDefinitions: CommenterDefinition[];
	lowConfidenceThreshold: number;
	onSegmentUpdate?: (id: string, newText: string) => void;
	onSegmentDelete?: (id: string) => void;
}

/**
 * TranscriptPanel component, memoized to prevent re-renders when other
 * unrelated state in the App (like comments or session status) changes.
 */
export const TranscriptPanel: React.FC<TranscriptPanelProps> = memo(
	({
		segments,
		commenterDefinitions,
		lowConfidenceThreshold,
		onSegmentUpdate,
		onSegmentDelete,
	}) => {
		return (
			<div className="bg-card-bg border border-border-main rounded-xl flex flex-col overflow-hidden flex-1 min-h-0">
				<div className="px-6 py-4 border-b border-border-main flex justify-between items-center bg-white/5 shrink-0">
					<div className="font-bold text-text-main flex items-center gap-2">
						<span role="img" aria-hidden="true">
							🎙️
						</span>{" "}
						ライブ文字起こし
					</div>
				</div>
				<TranscriptionDisplay
					segments={segments}
					commenterDefinitions={commenterDefinitions}
					showTimestamps={true}
					lowConfidenceThreshold={lowConfidenceThreshold}
					onSegmentUpdate={onSegmentUpdate}
					onSegmentDelete={onSegmentDelete}
				/>
			</div>
		);
	},
);
